import { render } from "./termUse.vue?vue&type=template&id=7406465e"
import script from "./termUse.vue?vue&type=script&lang=js"
export * from "./termUse.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__